export const classroomsReducedText = (classroomsSeparateByComma: string): string => {
  const firstCommaPosition = classroomsSeparateByComma.indexOf(',');
  const countComma = (classroomsSeparateByComma.match(/,/g) || []).length;
  let reducedText = classroomsSeparateByComma
  if (countComma > 0) {
    reducedText = classroomsSeparateByComma
      .substring(0, firstCommaPosition)
      .concat(' +')
      .concat(countComma.toString());
  }
  return reducedText
}